import React from "react";
import { connect } from "react-redux";
import { withRouter } from '../shared/hoc/withRouter';
import "moment/locale/en-gb";
import * as preferencesDuck from '../store/ducks/preferences.duck';
import { Navigate, Route, Routes } from "react-router-dom";
import { defaultLandingPage } from "../store/ducks/preferences.duck";
import { GetAccessRights } from "./Protector/Protector";
import { injectIntl } from "react-intl";
import { getLastLocation, forgotLastLocation } from "./RouterHelpers";

class NavigateToDefault extends React.Component {

  constructor(props) {
    super(props);
    if (props.IsFallbackFromLandingPageException) {
      alert(this.props.intl.formatMessage({ id: 'SYSTEM.WARNING.ACCESS_REVOKED_LANDING_PAGE' }));
      this.props.setLandingPage(null);
    }
    this.userLastLocation = getLastLocation();
    forgotLastLocation();

  }


  render() {
    const {
      location,
    } = this.props;
    let redirectPath = defaultLandingPage;
    if(this.userLastLocation && this.userLastLocation !== "/"){
      redirectPath = this.userLastLocation;
    }
    else if ((location.state || {}).from) {
      redirectPath = (location.state || {}).from;
    }
    else if (this.props.landingpage) {
      redirectPath = this.props.landingpage;
    }

    return (
      <Navigate replace to={redirectPath} />
    );
  }
}

const mapStateToProps = (store) => ({
  landingpage: store.preferences.landingpage,
});

const mapDispatchToProps = {
  setLandingPage: preferencesDuck.actions.setLandingPage,
};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(NavigateToDefault)));
